(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.controller('MessageViewController', ['messages', 'messageTypes', MessageViewControllerFn]);

    /* controller for main message grid view */
    function MessageViewControllerFn(messages, messageTypes) {
        var vm = this;
        // list of messages
        vm.messages = [];
        // list of transcriptions
        vm.transcriptions = [];
        // type of message (call, text message, ...)
        vm.messageTypes = null;


        activate();

        /* activation work */
        function activate() {
            vm.messageTypes = messageTypes ? messageTypes : null;
            if (messages.data) { 
                vm.messages = messages.data;
                vm.transcriptions = null;
            } else {
                vm.messages = messages.messages;
                vm.transcriptions = messages.transcriptions;
            }
        } //activate
    }
})();
